var $24fba9a73a2aba1c$exports = {};
$24fba9a73a2aba1c$exports = {
    "loading": `Cargando\u{2026}`,
    "loadingMore": `Cargando m\xe1s\u{2026}`
};


export {$24fba9a73a2aba1c$exports as default};
//# sourceMappingURL=es-ES.module.js.map
